msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: ko\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-30 06:44\n"
"Last-Translator: \n"
"Language-Team: Korean\n"
"Plural-Forms: nplurals=1; plural=0;\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: ko\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "잠김"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "게시물: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "마지막 게시일: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "자동화됨"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1454
msgid "Group"
msgstr "그룹"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "맞팔"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "요청함"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "팔로잉"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "날 팔로 함"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# 팔로워} other {# 팔로워}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "인증됨"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "<0>{0}</0> 가입"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "무기한"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "계정을 불러 올 수 없습니다."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "계정 페이지로 이동"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "팔로워"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "게시물"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "더 보기"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> 님은 새 계정으로 옮기셨습니다:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "핸들 복사됨"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "핸들을 복사할 수 없습니다"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "핸들 복사"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "원본 프로필 페이지로 가기"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "프로필 이미지 보기"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "프로필 헤더 보기"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "고인을 추모함"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "이 사용자는 해당 정보를 볼 수 없도록 설정했습니다."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0}개의 원문 게시물, {1}개의 댓글, {2}개의 부스트"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {지난 하루 동안 1개의 게시물} other {지난 {2}일 동안 1개의 게시물}}} other {{3, plural, one {지난 하루 동안 {4}개의 게시물} other {지난 {6}일 동안 {5}개의 게시물}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {지난 몇 해 동안 1개의 게시물} other {지난 몇 해 동안 {1}개의 게시물}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "원본"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1428
#: src/pages/catchup.jsx:2039
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "댓글"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1430
#: src/pages/catchup.jsx:2051
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "부스트"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "게시물 통계 못 봄."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "게시물 통계 보기"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "마지막 게시물: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "뮤트됨"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "차단됨"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "비공개 메모"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "<0>@{username}</0> 님 언급하기"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "소개문 번역"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "비공개 메모 고치기"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "비공개 메모 쓰기"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "@{username} 님의 게시물에 대한 알림 켜짐"

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "@{username} 님의 게시물에 대한 알림 꺼짐"

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "알림 끄기"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "알림 켜기"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "@{username} 님의 부스트 켜짐."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "@{username} 님의 부스트 꺼짐."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "부스트 끄기"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "부스트 켜기"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "리스트에서 더하기·빼기"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "링크 복사됨"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "링크를 복사할 수 없음"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "복사"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "공유 기능이 작동하지 않습니다."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "공유…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "@{username} 님 뮤트 풂"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "<0>@{username}</0> 님 뮤트 풀기"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "<0>@{username}</0> 님 뮤트…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "{0} 동안 @{username} 님 뮤트함"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "@{username} 님을 뮤트할 수 없음"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "<0>@{username}</0> 님을 팔로워에서 뺄까요?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} 님이 팔로워에서 빠짐"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "그만 팔로하기…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "<0>@{username}</0> 님을 차단할까요?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "@{username} 님 차단을 풂"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "@{username} 님을 차단함"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "@{username} 님 차단을 풀 수 없음"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "@{username} 님을 차단할 수 없음"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "<0>@{username}</0> 님 차단 풀기"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "<0>@{username}</0> 님 차단…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "<0>@{username}</0> 님 신고…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "프로필 고치기"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "팔로 요청을 취소할까요?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "@{0} 님을 그만 팔로할까요?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "그만 팔로하기…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "취소…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "팔로"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1564
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "닫기"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "번역된 소개문"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "리스트에서 뺄 수 없음."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "리스트에 더할 수 없음."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "리스트를 불러 올 수 없음."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "리스트가 없음."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "새 리스트"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "<0>@{0}</0> 님에 관한 비공개 메모"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "비공개 노트를 갱신할 수 없음."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "취소"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "저장하고 닫기"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "프로필을 갱신할 수 없음."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "소개문"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "기타 항목"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "레이블"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "내용"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "저장"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "사용자명"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "서버 도메인 이름"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "가리기 모드 꺼짐"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "가리기 모드 켜짐"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:434
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "홈"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "쓰기"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "저장되지 않은 변경 사항이 있습니다. 해당 게시물을 지우시겠습니까?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr ""

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "새 창으로 열기"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "최소화"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr ""

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr ""

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr ""

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "창 합치기"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "@{0} 님 게시물에 답글 달기(<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "@{0} 님 게시물에 답글 달기"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "원본 게시물 고치기"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "설문에는 적어도 2개 이상의 선택지가 있어야 합니다"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "선택지 중에 비어있는 게 있습니다"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "첨부한 매체 중에 설명이 없는 게 있습니다. 그래도 올릴까요?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "첨부 파일 #{i} 실패"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:978
msgid "Content warning"
msgstr "열람 주의"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "열람 주의 및 민감한 매체"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "공개"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "조용히 공개"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "팔로워만"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "쪽지"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "댓글 달기"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "게시물 고치기"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "지금은 무얼 하고 계신가요?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "민감하다고 표시"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "설문 넣기"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "커스텀 에모지 더하기"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "댓글"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "업데이트"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "올리기"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "움짤 받는 중…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "움짤 받기 실패"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "더 보기…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "올라감"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "이미지 설명"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "동영상 설명"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "오디오 설명"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "파일 크기가 너무 큽니다. 올리다가 문제가 생길 수 있습니다. 파일 크기를 {0}에서 {1} 이하로 줄여보세요."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "이미지 또는 동영상의 너비나 높이가 너무 큽니다. 올리다가 문제가 생길 수 있습니다. 너비와 높이를 {0}×{1} 픽셀에서 {2}×{3} 픽셀로 줄여보세요."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "초당 프레임 수가 너무 많습니다. 올리다가 문제가 생길 수 있습니다."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "지우기"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "오류"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "이미지 설명 고치기"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "동영상 설명 고치기"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "오디오 설명 고치기"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "설명을 자동 생성중. 잠시 기다려 주세요…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "설명을 자동 생성하는 데 실패했습니다: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "설명을 자동 생성하는 데 실패"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "설명 자동 생성…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "설명을 자동 생성하는 데 실패{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— 시범중</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "완료"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "선택지 {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "선다형 질문"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "기간"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "설문 지우기"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "계정 검색"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "더하기"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "계정 불러오기 오류"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "커스텀 에모지"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "에모지 검색"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "커스텀 에모지 불러오기 오류"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "최근 사용"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "기타"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0}개 더…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "움짤 검색"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "GIPHY 제공"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "움짤을 검색하려면 입력하세요"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:883
msgid "Previous"
msgstr "이전"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:900
msgid "Next"
msgstr "다음"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "GIF 불러오기 오류"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "올리지 않은 초고"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "아직 올리지 않은 초고가 있는 것 같습니다. 쓰다 만 곳에서 계속하세요."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "이 초고를 지울까요?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "초고를 지우다가 오류가 났습니다! 다시 한 번 시도해 보세요."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "지우기…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "댓글 달 게시물을 불러 올 수 없습니다!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "모든 초고를 지울까요?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "초고를 지우다가 오류가 나았습니다! 다시 한 번 시도해 보세요."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "모두 지우기…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "초고를 찾을 수 없었습니다."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1911
msgid "Poll"
msgstr "설문"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "매체"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "새 창에서 열기"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "수락"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "거절"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "수락함"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "거절함"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "표시할 내용 없음"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "계정"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:516
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "더 보기…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:521
#: src/pages/search.jsx:459
msgid "The end."
msgstr "끝"

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1602
msgid "Keyboard shortcuts"
msgstr "키보드 단축키"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "키보드 단축키 도움말"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1627
msgid "Next post"
msgstr "다음 게시물"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1635
msgid "Previous post"
msgstr "이전 게시물"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "다음 게시물로 캐러셀 넘기기"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "이전 게시물로 캐러셀 넘기기"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "새 게시물 불러오기"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1659
msgid "Open post details"
msgstr "게시물 자세히 보기"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> 또는 <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "열람 주의를 펼치거나<0/>글타래 펼치기·접기"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "게시물 혹은 창 닫기"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> 또는 <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "멀티 칼럼 모드에서 특정 칼럼으로 이동"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> 에서 <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "새 게시물 쓰기"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "새 게시물 쓰기 (새 창)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "게시물 올리기"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> 또는 <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "검색"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "댓글 (새 창)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "좋아요 (즐겨찾기)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> 또는 <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "부스트"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "책갈피"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "가리기 모드 켜고 끄기"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "리스트 고치기"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "리스트를 고칠 수 없습니다."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "리스트를 만들 수 없습니다."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "이름"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "리스트 구성원에게 단 댓글 보기"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "내가 팔로하는 사용자에게 단 댓글 보기"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "댓글은 숨기기"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "이 리스트의 게시물은 첫 화면 및 팔로잉 타임라인에서 가리기"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "만들기"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "리스트를 지울까요?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "리스트를 지울 수 없습니다."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "매체 설명"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "번역"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "말하기"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "원본 매체 새 창에서 열기"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "원본 매체 열기"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "이미지 설명을 생성중입니다. 잠시 기다려 주세요…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "이미지 설명 생성 실패"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "이미지 설명…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "게시물 보기"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "민감한 매체"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr ""

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:967
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1859
msgid "Filtered"
msgstr ""

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "게시물이 올라갔습니다. 확인 해 보세요."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "댓글이 올라갔습니다. 확인 해 보세요."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "게시물이 고쳐졌습니다. 확인 해 보세요."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "메뉴"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "새로 고침하여 업데이트 할까요?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "새 버전이 올라왔습니다…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "따라잡기"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "언급"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "알림"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "신규"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "프로필"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "리스트"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "모든 리스트"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "책갈피"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1429
#: src/pages/catchup.jsx:2045
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "좋아요"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "팔로하는 해시태그"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "필터"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "뮤트한 사용자"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "뮤트한 사용자들…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "차단한 사용자"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "차단한 사용자들…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "계정들…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "로그인"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "인기"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "로컬"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "연합"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "바로 가기·칼럼…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "설정…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "알림"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "이 알림은 나의 다른 계정에서 왔습니다."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "모든 알림 보기"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} 님이 내 게시물에 {emojiObject} 반응을 남겼습니다."

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} 님이 게시물을 올렸습니다."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr ""

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} 님이 나를 팔로하고 싶어합니다."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "만들었거나 투표한 설문 조사가 끝났습니다."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "만든 설문 조사가 끝났습니다."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "투표한 설문 조사가 끝났습니다."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "좋아했거나 부스트 한 게시물이 고쳐졌습니다."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} 님이 가입했습니다."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} 님이 {targetAccount} 님을 신고했습니다."

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "<0>{name}</0> 서버와 연결 끊김."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "조정 경고"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr ""

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "중재 경고를 받았습니다."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "계정이 비활성화되었습니다."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "일부 게시물이 민감한 게시물로 처리되었습니다."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "내 게시물 몇 개가 지워졌습니다."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "앞으로의 게시물은 민감하다고 표시됩니다."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "계정이 제한되었습니다."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "계정이 정지되었습니다."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[알 수 없는 알림 유형: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "부스트·좋아한 사용자…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "좋아한 사람:"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "부스트한 사람:"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "팔로한 사람:"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "자세히 보기 <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "더 보기 →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "투표함"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "결과 숨기기"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "투표"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "새로 고침"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "결과 보기"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, other {총 <1>{1}</1>표}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, other {총 <1>{1}</1>명}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "<0/>에 마감"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "마감"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "<0/> 내 마감"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "마감"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}초"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}분"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}시간"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "스팸"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "악성 링크, 허위 참여 또는 반복적인 댓글"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "불법"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "국내법 또는 서버 국가의 법을 위반"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "서버 규칙 위반"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "특정 서버 규칙 위반"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "위반"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "기타"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "어느 유형에도 속하지 않음"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "게시물 신고"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "@{username} 님 신고"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "검토 대기중"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "게시물 신고함"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "프로필 신고함"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "게시물을 신고할 수 없음"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "프로필을 신고할 수 없음"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "이 게시물에 어떤 문제가 있나요?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "이 프로필에 어떤 문제가 있나요?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "추가 정보"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "<0>{domain}</0>에 전달"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "신고하기"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "{username} 님 뮤트함"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "{username} 님을 뮤트할 수 없음"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "신고 <0>및 프로필 뮤트</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "{username} 님 차단함"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "{username} 님을 차단할 수 없음"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "신고 <0>및 프로필 차단</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr ""

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr ""

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr ""

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "홈·팔로잉"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "계정"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "해시태그"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "리스트 ID"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr ""

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "인스턴스"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "생략 가능 (예: mastodon.social)"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "검색어"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "멀티칼럼 모드가 아니면 생략 가능"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "예: 픽셀아트 (최대 5개, 띄어쓰기로 구분)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "매체만"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "바로 가기"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "베타"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "표시할 바로 가기 목록을 지정합니다:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "구석에 떠 있는 버튼"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "탭·메뉴 바"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "멀티칼럼"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "현재 보기 모드에서는 못 씀"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "위로 올리기"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "아래로 내리기"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "고치기"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr ""

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "아직 아무 칼럼도 없습니다. 칼럼 추가 버튼을 눌러 보세요."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "아직 아무 바로 가기도 없습니다. 바로 가기 추가 버튼을 눌러 보세요."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "뭘 넣어야 할 지 모르겠나요?<0/>우선 <1>홈·팔로잉과 알림</1>부터 넣어보세요."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "최대 {SHORTCUTS_LIMIT} 칼럼"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "최다 {SHORTCUTS_LIMIT}개의 바로 가기"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "가져오기·내보내기"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "칼럼 추가…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "바로 가기 추가…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr ""

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "바로 가기 고치기"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "바로 가기 추가"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "타임라인"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "리스트"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "<0>바로 가기</0> 가져오기·내보내기"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "가져오기"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "여기에 바로 가기를 붙이세요"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "인스턴스 서버에서 저장된 바로 가기를 받는 중…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "바로 가기 받을 수 없음"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr ""

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "* 현재 바로 가기에 이미 있음"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "다른 계정에서 온 리스트는 못 가져올 수 있습니다."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "잘못된 설정 형식"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "현재 바로 가기에 덧붙일까요?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr ""

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "바로 가기를 가져왔습니다. 최다치인 {SHORTCUTS_LIMIT}개를 넘겼으므로, 나머지는 가져오지 못했습니다."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr ""

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "가져와서 덧붙이기…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "바로 가기를 가져올까요?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "또는 덮어쓰기…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "가져오기…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "내보내기"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "바로 가기 복사됨"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "바로 가기를 복사할 수 없음"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "바로 가기 설정을 복사함"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "바로 가기 설정을 복사할 수 없음"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "공유"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "바로 가기를 인스턴스 서버에 저장중…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "바로 가기 저장됨"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "바로 가기를 저장할 수 없음"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "인스턴스 서버에 동기화"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, other {# 글자}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "바로 가기 JSON 코드"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "인스턴스 서버에서 설정 가져오기·인스턴스 서버에 설정 내보내기 (매우 시범적)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> 님이 <1>부스트 함</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "죄송합니다. 현재 로그인한 인스턴스는 다른 인스턴스에 있는 이 게시물과 상호작용할 수 없습니다."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "@{0} 님의 게시물을 좋아했던 것 취소"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "@{0} 님의 게시물 좋아함"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "@{0} 님의 게시물에서 책갈피 뺌"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "@{0} 님의 게시물에 책갈피 꽂음"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "부스트 취소"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "인용"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "첨부한 매체 중에 설명이 없는 게 있습니다."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "오래된 게시물 (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "@{0} 님의 게시물 부스트 취소"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "@{0} 님의 게시물 부스트"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "부스트…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "좋아요 취소"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "좋아요"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "책갈피 빼기"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "<0>@{0}</0> 님의 게시물 보기"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "수정 내역 보기"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "{editedDateText}에 고쳐짐"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "게시물 임베드하기"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "대화 뮤트 풀림"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "대화 뮤트됨"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "대화 뮤트를 풀 수 없음"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "대화를 뮤트할 수 없음"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "대화 뮤트 풀기"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "대화 뮤트하기"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "프로필에 고정됐던 게시물을 내림"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "게시물이 프로필에 고정됨"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "게시물 고정을 풀 수 없음"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "게시물을 고정할 수 없음"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "프로필에 고정된 게시물 내리기"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "프로필에 고정"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "게시물을 지울까요?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "게시물 지워짐"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "게시물 지울 수 없음"

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "게시물 신고…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "좋아함"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "부스트함"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "책갈피 꽂음"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "고정됨"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "지워짐"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, other {#개의 댓글}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "글타래{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "접기"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "내용 보기"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "매체 보기"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "고쳐짐"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "댓글들"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "수정 내역"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "내역 불러오기 실패"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "불러오는 중…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "HTML 코드"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "HTML 코드 복사됨"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "HTML 코드를 복사하지 못 함"

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "첨부된 매체:"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "계정 에모지:"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "정적 URL"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "에모지:"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "메모:"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "정적이며 스타일이나 JavaScript가 적용되지 않습니다. 필요에 따라 직접 스타일을 적용하시거나 고쳐서 쓰셔야 합니다."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "설문 조사는 상호작용하지 않으며, 투표수가 고정된 목록으로 표현됩니다."

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "첨부 매체는 이미지나 동영상, 오디오 등 아무 파일이나 됩니다."

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "원본 게시물은 나중에 고쳐지거나 지워질 수 있습니다."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "미리 보기"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "참고로 위 미리 보기는 다소 스타일이 적용되어 있습니다."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> 님이 부스트 함"

#: src/components/timeline.jsx:450
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "새 게시물"

#: src/components/timeline.jsx:551
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "재시도"

#: src/components/timeline.jsx:940
#: src/components/timeline.jsx:947
#: src/pages/catchup.jsx:1876
msgid "Thread"
msgstr "글타래"

#: src/components/timeline.jsx:962
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>필터됨</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "{sourceLangText}에서 자동 번역됨"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "번역중…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "{sourceLangText}(자동 인식됨)를 번역"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "{sourceLangText}를 번역"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "자동 ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "번역 실패"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr ""

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "@{0} 님께 댓글"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "이제 이 페이지를 닫아도 됩니다."

#: src/compose.jsx:70
msgid "Close window"
msgstr "창 닫기"

#: src/compose.jsx:86
msgid "Login required."
msgstr ""

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "홈 가기"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr ""

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ 댓글)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- 부스트)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr ""

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr ""

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr ""

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr ""

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr ""

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "댓글이 달린 게시물 보기"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ 댓글"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "부스트 빼고 게시물 보는 중"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- 부스트"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr ""

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr ""

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr ""

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "아직 표시할 내용이 없습니다."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "게시물을 불러 올 수 없습니다"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "계정 정보를 가져올 수 없음"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "해당 계정의 인스턴스로 전환 {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "내 인스턴스로 전환 (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr ""

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr ""

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "기본 계정"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr ""

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr ""

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "기본 계정으로 삼기"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr ""

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "로그아웃…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "다른 계정 추가"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "참고: <0>기본 계정</0>은 언제나 가장 먼저 뜹니다. 교체한 계정들은 세션 내내 유지됩니다."

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "책갈피를 불러 올 수 없습니다."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "지난 1시간"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "지난 2시간"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "지난 3시간"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "지난 4시간"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "지난 5시간"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "지난 6시간"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "지난 7시간"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "지난 8시간"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "지난 9시간"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "지난 10시간"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "지난 11시간"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "지난 12시간"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "12시간 이상"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr ""

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr ""

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr ""

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "따라잡기 <0>베타</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1568
msgid "Help"
msgstr "도움말"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "이게 무엇인가요?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "따라잡기는 이메일에서 영감을 받은 간단한 인터페이스의 별도 타임라인으로, 게시물들이 간편하게 정리 및 필터링되어 한눈에 파악할 수 있는 인터페이스입니다."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "따라잡기 미리 보기"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "따라잡아 볼까요?"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "내가 팔로하는 게시물들을 따라잡아 봅시다."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "다음 기간의 모든 게시물을 봅니다:"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "최대한 많이"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "따라잡기"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "마지막 따라잡기와 기간이 겹칩니다"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "마지막 따라잡기 때({0})까지"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "주의: 인스턴스가 기간 설정과 무관하게 타임라인에서 최대 800개(또는 내외)의 게시물까지만 보여줄 수도 있습니다."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "이전 따라잡기:"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, other {게시물 #개}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "이 따라잡기를 지울까요?"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "참고: 총 3개까지만 보존됩니다. 나머지는 알아서 지워집니다."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "게시물 불러오는 중…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "시간이 조금 걸릴 수 있습니다."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "필터 초기화"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1574
msgid "Top links"
msgstr "인기 링크"

#: src/pages/catchup.jsx:1260
msgid "Shared by {0}"
msgstr ""

#: src/pages/catchup.jsx:1299
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr ""

#: src/pages/catchup.jsx:1384
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, other {글쓴이 #명}}"

#: src/pages/catchup.jsx:1396
msgid "Sort"
msgstr "정렬"

#: src/pages/catchup.jsx:1427
msgid "Date"
msgstr "날짜"

#: src/pages/catchup.jsx:1431
msgid "Density"
msgstr "밀도"

#: src/pages/catchup.jsx:1469
msgid "Authors"
msgstr "글쓴이"

#: src/pages/catchup.jsx:1470
msgid "None"
msgstr "안 묶음"

#: src/pages/catchup.jsx:1486
msgid "Show all authors"
msgstr "모든 글쓴이 보기"

#: src/pages/catchup.jsx:1537
msgid "You don't have to read everything."
msgstr "다 읽을 필요는 없답니다."

#: src/pages/catchup.jsx:1538
msgid "That's all."
msgstr "이게 다입니다."

#: src/pages/catchup.jsx:1546
msgid "Back to top"
msgstr "맨 위로 올라가기"

#: src/pages/catchup.jsx:1577
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "팔로한 사람들이 공유한 링크를 공유·부스트·좋아요 수가 많은 순서로 보여줍니다."

#: src/pages/catchup.jsx:1583
msgid "Sort: Density"
msgstr "정렬: 밀도"

#: src/pages/catchup.jsx:1586
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "게시물을 정보 밀도가 높거나 낮은 순서로 보여줍니다. 짧은 게시물은 정보 밀도가 “낮고”, 긴 게시물은 “높다”고 봅니다. 이미지가 첨부된 게시물은 이미지가 없는 게시물보다 정보 밀도가 “높다”고 봅니다."

#: src/pages/catchup.jsx:1593
msgid "Group: Authors"
msgstr "묶기: 글쓴이"

#: src/pages/catchup.jsx:1596
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "글이 글쓴이에 따라 묶이며, 게시물이 많은 글쓴이가 앞에 나옵니다."

#: src/pages/catchup.jsx:1643
msgid "Next author"
msgstr "다음 글쓴이"

#: src/pages/catchup.jsx:1651
msgid "Previous author"
msgstr "이전 글쓴이"

#: src/pages/catchup.jsx:1667
msgid "Scroll to top"
msgstr "맨 위로"

#: src/pages/catchup.jsx:1858
msgid "Filtered: {0}"
msgstr ""

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr ""

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "홈 및 리스트"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr ""

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "대화"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "프로필"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr ""

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "새 필터"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr ""

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr ""

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr ""

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr ""

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "필터 고치기"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "필터를 고칠 수 없음"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "필터를 생성할 수 없음"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "제목"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "전체 단어"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "검색어가 없으니 추가하세요."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "검색어 추가"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, other {검색어 #개}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr ""

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "※ 아직 미구현"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr ""

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "최소화됨"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "숨김"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "이 필터를 지울까요?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "필터를 지울 수 없습니다."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr ""

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr ""

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, other {해시태그 #개}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "팔로하는 해시태그를 불러 올 수 없습니다."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "아직 아무 해시태그도 팔로하지 않습니다."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "표시할 내용이 없습니다."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "게시물을 불러 올 수 없습니다."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{instance} 상의 {hashtagTitle} (매체만)"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{instance} 상의 {hashtagTitle}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (매체만)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr ""

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "해당 태그를 포함한 게시물을 불러올 수 없습니다"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} 팔로 풂"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "#{hashtag} 팔로함"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "팔로잉…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "프로필에 내보임"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "프로필에 내보이기"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr ""

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "해시태그 더하기"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "해시태그 지우기"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "이 바로 가기는 이미 있습니다"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "해시태그 바로 가기가 추가됨"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "바로 가기 추가"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "새 인스턴스 입력 (예: mastodon.social)"

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "잘못된 인스턴스"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "다른 인스턴스로 가기…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "내 인스턴스(<0>{currentInstance}</0>)로 가기"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr "알림을 불러 올 수 없습니다."

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>새</0> <1>팔로 요청</1>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "모두 보기"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "불러오는 중…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "URL을 불러올 수 없음"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "아직 아무 것도 없습니다."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "구성원 관리"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "<0>@{0}</0> 님을 리스트에서 뺄까요?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "지우기…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, other {리스트 #개}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "아직 아무 리스트도 없습니다."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "예: “mastodon.social”"

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr ""

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "계속"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "계정이 없으신가요? 하나 만드세요!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "쪽지"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "쪽지"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "아무도 언급하지 않았습니다"

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "언급을 가져올 수 없습니다."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "팔로하지 않은 사람"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "날 팔로하지 않는 사람"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr ""

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr ""

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "알림 설정"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "새 알림"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, other {공지}}"

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "팔로 요청"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, other {팔로 요청 #건}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, other {#사람으로부터 필터된 알림}}"

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "내 언급만"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "오늘"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr "모두 따라잡았습니다."

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "어제"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "알림을 가져올 수 없음"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "알림 설정이 바뀜"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "다음 사용자로부터 알림을 제외:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr ""

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr ""

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "<0>{0}</0> 업데이트됨"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr ""

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "닫기"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr "닫힘"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr ""

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr ""

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr ""

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr ""

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr ""

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr ""

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr ""

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr ""

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr ""

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "해시태그"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "더 보기"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "계정 더 보기"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "아무 계정도 찾을 수 없습니다."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "해시태그 더 보기"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "아무 해시태그도 찾을 수 없습니다."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "게시물 더 보기"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "아무 게시물도 찾을 수 없습니다."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "시작하려면 위 검색창에 검색어를 입력하거나 URL을 붙여 넣으세요."

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "설정"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "외관"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "밝게"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "어둡게"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "자동"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "글자 크기"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "글"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "표시 언어"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr "번역 참여하기"

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "게시"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr "기본 공개 범위"

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "동기화 됨"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr "게시물 공개 범위 수정 실패"

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "인스턴스 서버의 설정과 동기화 됩니다. <0>쓰고 있는 인스턴스({instance})에서 더 많은 설정이 가능합니다.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "시범 기능"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "타임라인 게시물 알아서 새로 고침"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr "부스트 캐러셀"

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "게시물 번역"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "다음 언어로 번역:"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "시스템 언어 ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {다음 언어에 대해 “번역” 버튼 가리기:} other {다음 #개 언어에 대해 “번역” 버튼 가리기:}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "참고: 이 기능은 외부 번역 서비스인 <0>Lingva API</0> & <1>Lingva Translate</1>를 이용합니다."

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr "자동 번역"

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "타임라인에서 게시물에 번역을 자동으로 보여줍니다. 열람 주의나 매체, 설문 조사가 없는 <0>짧은</0> 게시물에만 적용 됩니다."

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr "글쓰기 창에서 움짤 고르기"

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "이 기능은 외부 움짤 검색 서비스인 <0>GIPHY</0>를 이용합니다. 전체관람가 움짤만 제공되며, 추적 매개변수는 제거되고 리퍼러 정보는 요청에서 생략되지만, 그럼에도 검색어와 IP 주소 정보는 해당 서비스에 전달 됩니다."

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "이미지 설명 자동 생성기"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr "새 게시물을 쓸 때 새로운 이미지에만 적용 됩니다."

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "참고: 이 기능은 외부 인공지능 서비스인 <0>img-alt-api</0>를 이용합니다. 잘 동작하지 않을 수 있으며, 이미지에만 적용 가능하고 영어만 지원합니다."

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr "서버측에서 알림 묶기"

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "알파 단계 기능입니다. 묶음의 크기가 커질 수도 있지만, 묶는 규칙은 기초적입니다."

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr ""

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "가리기 모드 <0>(<1>글자들</1> → <2>███</2>)</0>"

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "글자를 모두 네모로 바꿔서 개인정보 염려 없이 스크린숏을 캡처할 수 있게 합니다."

#: src/pages/settings.jsx:692
msgid "About"
msgstr "정보"

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<1>@cheeaun</1>이 <0>만듦</0>"

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr "후원자"

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "기부"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "개인 정보 보호 정책"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr "<0>사이트:</0> {0}"

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>버전:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr "버전 번호 복사 됨"

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr "버전 번호를 복사할 수 없음"

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr "구독을 갱신하는 데 실패했습니다. 다시 시도해 보세요."

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "푸시 알림 (베타)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr "<0>{0}</0>에게서 알림 받기"

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr "모두"

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr "내가 팔로하는 사람들"

#: src/pages/settings.jsx:999
msgid "followers"
msgstr "팔로워"

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr "팔로"

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "설문 조사"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr "게시물 수정"

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "주의: 푸시 알림은 <0>단 하나의 계정</0>에만 작동합니다."

#: src/pages/status.jsx:565
msgid "Post"
msgstr "게시물"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr ""

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "댓글을 불러 올 수 없습니다."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "뒤로"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr "원 게시물로 이동하기"

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr ""

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr "전환할 수 없음"

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr "게시물의 인스턴스로 전환 ({0})"

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr "게시물의 인스턴스로 전환"

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr "게시물을 불러 올 수 없습니다"

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, other {댓글 <0>{1}</0>개}}"

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, other {댓글 <0>{0}</0>개}}"

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr "게시물과 댓글 보기"

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "인기 ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "인기 뉴스"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr "인기 게시물 보기로 되돌아가기"

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "<0>{0}</0> 님을 언급하는 게시물 보기"

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr "인기 게시물"

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr "인기 게시물이 없음."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "미니멀리즘을 추구하는 Mastodon 웹 클라이언트."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Mastodon으로 로그인"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "가입"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "부스트 캐러셀의 스크린숏"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "부스트 캐러셀"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "한 칼럼 혹은 멀티칼럼"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "기본적으로는 젠 모드를 추구하는 분들을 위해 한 칼럼으로 보입니다. 고급 사용자들을 위한 멀티 칼럼도 설정 가능합니다."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "다중 해시태그 타임라인"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "한 타임라인에 최대 5개 해시태그까지 지정할 수 있습니다."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "웹브라우저에서 팝업 윈도를 차단한 것 같습니다."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""

